import { ref, watch } from 'vue';

const NAV_MODE_KEY = 'advup_nav_mode';
const navMode = ref(localStorage.getItem(NAV_MODE_KEY) || 'vertical');

watch(navMode, val => localStorage.setItem(NAV_MODE_KEY, val));

export function useNavMode() {
  const toggleNavMode = () => {
    navMode.value = navMode.value === 'vertical' ? 'horizontal' : 'vertical';
  };
  return { navMode, toggleNavMode };
}
